import { render } from "./AccessWorkspace.vue?vue&type=template&id=27a4f6fc&scoped=true"
import script from "./AccessWorkspace.vue?vue&type=script&lang=js"
export * from "./AccessWorkspace.vue?vue&type=script&lang=js"

import "./AccessWorkspace.vue?vue&type=style&index=0&id=27a4f6fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a4f6fc"]])

export default __exports__